'use client'

import dynamic from 'next/dynamic'

import { Ring2 } from 'ldrs/react'
import useInfiniteScroll from 'react-infinite-scroll-hook'

import { AppsCardSkeleton } from '@/components/skeletons'
import { useActivityList } from '@/lib/api/hooks/apps'

// 动态导入重组件，减少首屏 JS 体积（保留 SSR，首屏卡片需出现在 HTML 中以优化 LCP）
const AppsBannerCard = dynamic(
  () => import('@/components/business').then(mod => ({ default: mod.AppsBannerCard }))
)

/**
 * Apps 页面内容区域
 * 展示所有 Apps 数据，支持无限滚动加载
 */
export function AppsPageContent() {
  const { list, isLoading, hasMore, loadMore, isFetchingNextPage } = useActivityList()

  const [infiniteRef] = useInfiniteScroll({
    loading: isFetchingNextPage,
    hasNextPage: hasMore,
    onLoadMore: loadMore,
    rootMargin: '0px 0px 200px 0px',
    disabled: !hasMore
  })

  return (
    <>
      <div className="page-container">
        {isLoading ? (
          <div className="grid w-full grid-cols-2 gap-2 md:grid-cols-4 lg:grid-cols-7">
            {Array.from({ length: 14 }).map((_, index) => (
              <AppsCardSkeleton key={index} className="aspect-[3/4] !size-full" />
            ))}
          </div>
        ) : (
          <div className="grid w-full grid-cols-2 gap-2 md:grid-cols-4 lg:grid-cols-7">
            {list.map(item => (
              <AppsBannerCard
                key={item.id}
                className="aspect-[3/4] !size-full"
                data={item}
                type="activity"
              />
            ))}
          </div>
        )}
      </div>

      <div ref={infiniteRef} className="my-2 flex items-center justify-center">
        {isFetchingNextPage && <Ring2 color="white" size={20} stroke={2} />}
      </div>
    </>
  )
}
